export const validText = new RegExp("^[a-zA-Z0-9-]*$");
export const validContainsHebrew = new RegExp('(?=.*[א-ת])');
export const validOnlyNumber = new RegExp('(?=[^0-9])');
export const validTz = (tz) => {
	var id = String(tz).trim();
	if (id.length > 9 || id.length < 5 || isNaN(id)) return false;

	// Pad string with zeros up to 9 digits
	id = id.length < 9 ? ("00000000" + id).slice(-9) : id;

	return Array
		.from(id, Number)
		.reduce((counter, digit, i) => {
			const step = digit * ((i % 2) + 1);
			return counter + (step > 9 ? step - 9 : step);
		}) % 10 === 0;
}